import { getCustomDataLabelsOptions } from '../reusableGraphOptions'
import { formatReportNumber } from '../../../../../features/formatters'

export const getOptions = ({ legendContainerId, datasets, currencySymbol }) => {
  const maxValueInDataSets = Math.max(...datasets.map(data => Math.max(...data.data)))

  return {
    scales: {
      x: {
        ticks: {
          display: true,
          color: '#000',
          font: {
            size: 17,
            weight: 400
          }
        },
        grid: {
          display: false
        },
        border: {
          dash: [6, 6],
          display: true,
          color: '#000'
        }
      },
      y: {
        ticks: {
          display: false
        },
        grid: {
          drawBorder: false,
          drawOnChartArea: true,
          dash: [6, 6]
        },
        border: {
          display: false,
          dash: [6, 6]
        }
      }
    },

    // legend:
    plugins: {
      legend: { display: false },
      htmlLegend: {
        // ID of the container to put the legend in
        containerID: legendContainerId
      },
      datalabels: getCustomDataLabelsOptions({ maxValue: maxValueInDataSets, fontSize: 9, currencySymbol }),
      tooltip: {
        callbacks: {
          label: tooltipItem =>
            formatReportNumber({ value: tooltipItem.raw, format: 'currency', currency: currencySymbol })
        }
      }
    }
  }
}
